<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" label="库房" v-if="getIsView()">
                <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getWarehousesBySessionWarehouseId" @change="outWarehouseChange" style="width:100%">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>库房:{{ form.warehouseName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发起人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
          </el-row>

          
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" type="danger" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
            <el-input :disabled="!editMode" placeholder="扫描标签码添加明细" v-model="tagCode" ref="tagCodeInput" style="width:300px;margin-left:30px" @change="tagCodeChange"></el-input>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details"  style="width: auto; margin: 0 10px"  @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="selection" width="55" align="center" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="productName" label="产品" width="180" > 
              <template slot-scope="scope">
               <SelectTable :disabled="!editMode" :columns="threeStockColums" :innerName="scope.row.productName" :dataList="STATIC_Stocks" @filterMethod="getProductList" @change="(data)=>productChange(scope.row,data)" />
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" label="产品规格" width="130" ></el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
            <el-table-column prop="packSpec" label="包装规格" width="120"></el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
            <el-table-column prop="batch" label="批次号" width="120"> </el-table-column>
            <el-table-column prop="serialNo" label="序列号" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="stockQuantity" label="库存数量" width="120"></el-table-column>
             
             <el-table-column show-overflow-tooltip prop="locationName" label="货位" width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="number" label="移动数量" width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.number" :disabled="!editMode" type="number" :max="scope.row.stockQuantity" min="1" ></el-input>
                </template>
              </el-table-column>
               <el-table-column show-overflow-tooltip prop="newLocationName" label="新货位" width="120">
                <template slot-scope="scope">
                 <el-select :disabled="!editMode" v-model="scope.row.newLocationName" placeholder="请选择货位" @change="(val)=>newLocationNameChange(scope.row,val)" style="width: 100%" >
                  <el-option v-for="item in STATIC_Locations" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                </el-select>
                </template>
               </el-table-column>
            
                   <el-table-column prop="manufactureDate" label="生产日期" width="150">
              <template slot-scope="scope">
                {{scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : ""}}
              </template>
            </el-table-column>
               <el-table-column prop="validityDate" label="有效期" width="150">
              <template slot-scope="scope">
                {{ scope.row.validityDate? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}") : ""}}
              </template>
            </el-table-column>
              <el-table-column prop="longTime" label="长期" width="60">
              <template slot-scope="scope">
                {{ scope.row.longTime == 1 ? "是" : "否"}}
              </template>
            </el-table-column>
                <el-table-column prop="price" label="采购价" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="130"></el-table-column>
              <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" width="130"></el-table-column>
               <el-table-column show-overflow-tooltip prop="mainNo" label="主条码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="traceNo" label="追溯码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证" width="180"></el-table-column>
            <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import OutStockScan from '@/mixin/outStockScan-mixin'
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  GetLocationMoveById,
  RejectLocationMove,
  SaveLocationMove,
  GetTagCodeList,
  GetWarehouses,
  GetWarehouseById
} from "@/api";
import { StockCategoryOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, OutStockScan,tagCodeMixin],
  components: {
    SelectTable,
    ApproveInfo,
    LabelDetailsDialog,
    PackageLabelDialog
  },
  data () {
    return {
      GetDataAction: GetLocationMoveById,
      SaveDataAction: SaveLocationMove,
      reject: RejectLocationMove,
      form: {},
      StockCategoryOptions: StockCategoryOptions,
      rules: {
        warehouseName: [
          { required: true, message: '请选择库房', trigger: 'blur' }
        ],
        inWarehouseId: [
          { required: true, message: '请选择调入库房', trigger: 'blur' }
        ],
      },
 
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,

      isScan: false,
      outLocationList: [],
      inWarehouseList: [],
      inLocationList: [],
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
   
    }

    this.getWarehousesBySessionWarehouseId('')
    // this.getSuppliers('');
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;

      if (this.form.warehouseId) {
        this.outWarehouseChange(this.form.warehouseId)
      }

    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        // this.getLocations(this.form.outWarehouseId);
        // this.getLocations(this.form.inWarehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

        // this.outWarehouseChange(this.form.warehouseId)
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
          if(this.form.details.length == 0){
          this.$my_message(`请添加明细`, "warning");
          return;
        }
        var productValidate = this.locationMoveProductDetailRepeatValidate(this.form.details);
        if (!productValidate.flag) {
          this.$my_message(productValidate.msg, "warning");
          this.$store.dispatch('SetLoading', false)
          return;
        }
        
        // 校验明细行的newLocationId不能为空
        const emptyLocationRow = this.form.details.find(item => !item.newLocationName);
        console.log(emptyLocationRow);
        
        if (emptyLocationRow) {

          
          this.$my_message(`第${emptyLocationRow?.$index}行明细的新货位不能为空，请选择`, "warning");
          this.$store.dispatch('SetLoading', false);
          return;
        }
        
        this.form.isCreated = 0
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        deliveryTime: new Date(),
        // "warehouseId": this.userInfo.defaultWarehouseId,
        // warehouseName: this.userInfo.defaultWarehouseName,
        // outWarehouseManagerId: this.userInfo.defaultWarehouseManagerId,
        // outWarehouseManagerName: this.userInfo.defaultWarehouseManagerName,
        details: [],
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        orgCode :sessionStorage.getItem('orgId'),
      };


    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.form.details.push({
        number: 0,
        newLocationName: '',
        $index : this.form.details.length + 1
      })
       this.getLocations(this.form.warehouseId);
      this.getProductList('')
    },
    handleDeleteChildForm () {
      if(this.checkIsRfid(this.childMultipleSelection)){
        this.$my_message(`存在打包类标签明细，不能删除！`, "warning");
        return
      }
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
 
   
    outWarehouseChange (val) {
      this.form.warehouseId = val
      GetWarehouseById({ id: val })
        .then(res => {
          this.form.warehouseName = res.returnData.name
          this.form.warehouseManagerId = res.returnData.managerId
          this.form.warehouseManagerName = res.returnData.managerName
          this.outLocationList = res.returnData.details
          this.form.details = []
          this.getProductList('')
          this.getInWarehouseList('')
          this.getLocations(this.form.warehouseId)
        })
    },
    inWarehouseChange (val) {
      this.form.inWarehouseId = val
      GetWarehouseById({ id: val })
        .then(res => {
          this.form.inWarehouseName = res.returnData.name
          this.form.inWarehouseManagerId = res.returnData.managerId
          this.form.inWarehouseManagerName = res.returnData.managerName
          this.inLocationList = res.returnData.details
          let deptIds = res.returnData.deptIds.split(';')
          this.form.inWarehouseDeptId = deptIds[0]
        })
    },
    productChange (row, data) {
      // 找到当前行在form.details数组中的索引
      const index = this.form.details.findIndex(item => item === row);
         data.number = data.stockQuantity
      if (index !== -1) {
        // if(data.hasTagCode==1){
        //     GetTagCodeList({
        //     stockIds: data.id,
        //     pageSize:999
        //   }).then((res) => {
        //     data.tagCodeViewModels = res.returnData.data;
         
        //     this.$set(this.form.details, index, JSON.parse(JSON.stringify(data)));
            
        //   });
        // }else{
            // 使用Vue的响应式方式更新数
            data.hasTagCode = 0
            data.tagCodeIds = ''
            data.$index = row.$index
        this.$set(this.form.details, index, JSON.parse(JSON.stringify(data)));
        // }
      
      }
    },
    getProductList (keyWord) {
      let query = {
        // userId: this.storage.getItem('user').id,
        pageIndex: 1,
        pageSize: 50,
        keyWord: keyWord,

        warehouseId: this.form.warehouseId
      }
      this.getStocks(query)
    },
    getInWarehouseList (val) {
      let query = {
        pageIndex: 1,
        pageSize: 50,
        keyWord: val,
        state: 1
      }
      GetWarehouses(query)
        .then(res => {
          this.inWarehouseList = res.returnData.data
        })
    },
    newLocationNameChange(row,val){
      this.STATIC_Locations.forEach(item => {
        if(item.id == val){
          row.newLocationName = item.name
        }
      })
      row.newLocationId = val
    },
 
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
